import { Asset } from "@hydrologiq/gql/graphql"
import Figure from "../generic/Figure"
import FigureContent from "../generic/FigureContent"
import LocationAttribute from "@hydrologiq/shared/attributes/Location"
import { useCopyValues } from "@hydrologiq/shared/providers/helpers/useCopy"
import { COPY_KEYS, DEFAULT_COPY_MAPPINGS } from "@hydrologiq/shared/copy/constants"
import { isCompactFigure } from "@hydrologiq/shared/figures/generic/figureVariant"

export interface DeployedAtProps {
  context?: Asset
}

const DeployedAt = ({ context }: DeployedAtProps) => {
  const site = context?.reserved_site
  const loading = context?.reserved_site === undefined && !site
  const isPlaceholder = !context
  const copy = useCopyValues({
    [COPY_KEYS.HEADINGS.SITE]: DEFAULT_COPY_MAPPINGS[COPY_KEYS.HEADINGS.SITE],
  })

  return (
    <Figure heading={copy[COPY_KEYS.HEADINGS.SITE]} loading={loading} isPlaceholder={isPlaceholder} compact={isCompactFigure("summary")}>
      <FigureContent.Root>
        <FigureContent.SubText>assigned to</FigureContent.SubText>
        <FigureContent.Value>
          {site ? (
            <LocationAttribute location={undefined} background={false} name={site?.name} larger />
          ) : (
            "No reservation"
          )}
        </FigureContent.Value>
      </FigureContent.Root>
    </Figure>
  )
}

export default DeployedAt
